export function getDaysDifferent(date){
    const timestampDate = date * 1000;
    const currentDate = (new Date()).getTime();

    const diffTime = currentDate - timestampDate;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    return diffDays
}